module.exports = __webpack_public_path__ + "static/media/table-tennis.a53786b8.svg";